<template>
	<div class="control">
		<div class="form-group">
			<input id="app-search-input" class="form-control" v-bind:class="className" type="text" v-model="query" v-bind:placeholder="control.placeholder" v-on:keyup.enter="updateFilters" />
			<label class="sr-only" for="app-search-input">Search</label>
			<button v-if="control.searchButton" 
				v-bind:disabled="query == undefined || query.length == 0"
				v-on:click="updateFilters">
				<span class="sr-only">search</span><i class="fas fa-search"></i>
			</button>
			<span v-if="query" title="Clear" v-on:click="clearSearchTerm()" class="fas fa-times-circle search-clear"></span>
		</div>
	</div>
</template>

<script>
    import he from 'he';
	import { mapState, mapActions, mapMutations } from 'vuex';

	export default {
		props: ['control', 'className', 'parent'],
		data: function () {
			return {
				query: he.decode(this.parent.defaultValue),
            }
		},
        mounted: function () {
			// clear current input on reset
			this.$store.subscribe((mutation, state) => {
				if (mutation.type === 'listing/resetSpecification') {
					this.query = this.control.defaultValue;
				}
            });
		},
		methods: {
            ...mapMutations('listing', { updateSpecification: 'updateSpecification' }),
			clearSearchTerm() {
				
				if (this.query !== '') {
					this.query = '';
					this.updateFilters();
				}
			},
            updateFilters() {
				this.updateSpecification({ key: this.control.specification, value: he.decode(this.query) });
			},
		}
	}
</script>